export default "__VITE_ASSET__Dmmx80mN__"